import React, { useEffect, useState } from "react";
import Select from "react-select";
import CreatableSelect from "react-select/creatable";
import { useTranslation } from "react-i18next";
import ButtonComponent from "../../../components/ButtonComponent";
import { COLORS } from "../../../lib/colors";
import * as HTTPServices from "../../../api/HTTPServices";

import classes from "./index.module.scss";

function Index() {
  const { t } = useTranslation();
  const [selectedSpecial, setSelectedSpecial] = useState([]);
  const [optionsSpecialties, setOptionsSpecialties] = useState([]);
  //
  const [selectedSkill, setSelectedSkill] = useState([]);
  const [optionsSkills, setOptionsSkills] = useState([]);
  const [skillsLoading, setSkillsLoading] = useState(false);
  //
  const [passportImageData, setPassportImageData] = useState("");
  const [specialCartImageData, setspecialCartImageData] = useState("");

  useEffect(() => {
    const RequestService = HTTPServices.getMethod("doctor_info", "", "true");
    RequestService.then(function (response) {
      if (response) {
        // LiveObject.setState({
        //     passport_image_data: response.passport_image,
        //     national_cart_image_data: response.national_cart_image,
        //     special_cart_image_data: response.special_cart_image,
        //     education_image_data: response.education_image,
        //     doctor_status: response.doctor_status,
        //     optionsSkills: response.skills_option,
        //     optionsSpecialties: response.specialties_option,
        //     selectedSpecial: JSON.parse(response.special),
        //     selectedSkill: JSON.parse(response.skill),
        // });

        setSelectedSpecial(JSON.parse(response.special));
        setOptionsSpecialties(response.specialties_option);
        //
        setSelectedSkill(response.skill);
        setOptionsSkills(response.skills_option);
        //
        setPassportImageData(response.passport_image);
        setspecialCartImageData(response.special_cart_image);
      }
    }).catch(function (error) {});
  }, []);

  const handleChangeSpecial = (selectedSpecial) => {
    setSelectedSpecial(selectedSpecial);
  };

  const handleChangeSkill = (selectedSkill) => {
    setSelectedSkill(selectedSkill);
  };

  const handleCreateSkill = (inputValue) => {
    setSkillsLoading(true);
    const params = new URLSearchParams();
    params.append("name", inputValue);

    const RequestService = HTTPServices.postMethod(
      "create_skill",
      params,
      "true"
    );
    RequestService.then(function (response) {
      if (response) {
        setOptionsSkills(response.skills_option);

        setSelectedSkill([...selectedSkill, response.new_option]);
      }

      setSkillsLoading(false);
    }).catch(function (error) {
      setSkillsLoading(false);
    });
  };

  const handleSubmit = (event) => {
    event.preventDefault();

    let formData = new FormData();

    formData.append("special", JSON.stringify(selectedSpecial));
    formData.append("skill", JSON.stringify(selectedSkill));

    const RequestService = HTTPServices.postMethod(
      "doctor_info",
      formData,
      "true",
      "post",
      "true"
    );
    RequestService.then(function (response) {
      if (response) {
      } else {
      }
    }).catch(function (error) {});
  };

  return (
    <div className={classes.mainContainer}>
      <h3 className={classes.title}>
        {t("pages.protectedPages.doctorInfo.title")}
      </h3>
      <hr></hr>
      <h4 style={{ padding: 10 }}>
        {t("pages.protectedPages.doctorInfo.header")}
      </h4>
      <div
        style={{
          display: "flex",
          justifyContent: "space-between",
          padding: 10,
        }}
      >
        <div>
          <p>{t("pages.protectedPages.doctorInfo.idCard")}</p>
        </div>
        <div>
          {passportImageData && (
            <a
              className="link_image"
              href={passportImageData}
              target="_blank"
              rel="noreferrer"
            >
              {t("pages.protectedPages.doctorInfo.viewImage")}
            </a>
          )}
        </div>
      </div>

      <div
        style={{
          display: "flex",
          justifyContent: "space-between",
          padding: 10,
        }}
      >
        <p>{t("pages.protectedPages.doctorInfo.medSysCard")}</p>

        {specialCartImageData && (
          <a
            className="link_image"
            href={specialCartImageData}
            target="_blank"
            rel="noreferrer"
          >
            {t("pages.protectedPages.doctorInfo.viewImage")}
          </a>
        )}
      </div>
      <div style={{ padding: 10 }}>
        <p>{t("pages.protectedPages.doctorInfo.officeLisence")}</p>
        <p>{t("pages.protectedPages.doctorInfo.specialties")}</p>
      </div>
      <Select
        value={selectedSpecial}
        onChange={handleChangeSpecial}
        options={optionsSpecialties}
        placeholder={t("pages.protectedPages.doctorInfo.example1")}
        noOptionsMessage={() => "nothing found"}
        isMulti={true}
      />
      <p>{t("pages.protectedPages.doctorInfo.skills")}</p>
      <CreatableSelect
        value={selectedSkill}
        onChange={handleChangeSkill}
        options={optionsSkills}
        placeholder={t("pages.protectedPages.doctorInfo.example2")}
        noOptionsMessage={() => "nothing found"}
        isMulti={true}
        isClearable={true}
        isDisabled={skillsLoading}
        isLoading={skillsLoading}
        onCreateOption={handleCreateSkill}
        formatCreateLabel={function (inputValue) {
          return 'add skill "'.concat(inputValue, '" to list');
        }}
      />

      <div style={{ textAlign: "center", marginTop: 20 }}>
        <ButtonComponent
          backgroundColor={COLORS.primary}
          width="150px"
          onClick={handleSubmit}
        >
          {t("pages.protectedPages.doctorInfo.save")}
        </ButtonComponent>
      </div>
    </div>
  );
}

export default Index;
